import { createSvgComponent } from "../../icon/createSvgComponent";
import ChatQuestion from "@core/icon/assets/chat-question.svg";
export default createSvgComponent(ChatQuestion);